import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=cbe4bc70"
import script from "./table-body.vue?vue&type=script&lang=js"
export * from "./table-body.vue?vue&type=script&lang=js"
import style0 from "./table-body.vue?vue&type=style&index=0&id=cbe4bc70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports